// extracted by mini-css-extract-plugin
export default {"container":"ComingSoon_container__6ux3J","image":"ComingSoon_image__BTUc8"};